import { createFileRoute, Link, Outlet } from "@tanstack/react-router";
import { requireAuth } from "@/auth/require-auth";

export const Route = createFileRoute("/_settings")({
  beforeLoad: requireAuth,
  component: SettingsLayout,
});

function SettingsLayout() {
  return (
    <div>
      <header>
        <Link to="/">&larr; Back</Link>
      </header>
      <br />
      <br />
      <br />
      <main>
        <Outlet />
      </main>
    </div>
  );
}
